import axios from 'axios';
import { logoutApiUrl } from '@/GlobalConfig/app-config';


class LogoutService{
    
    constructor(){}

    public async logout(saveData:any){
      const Url = logoutApiUrl;
      return axios({
        method: 'post',
        url: Url,
        data: saveData,
      });
    }
}

export const logoutService = new LogoutService();